export default "__VITE_ASSET__03d26a92__"